import { z } from 'zod';
export const HealthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    client: z.string(),
    db: z.enum(['ok', 'down']),
    time: z.string(),
});
//# sourceMappingURL=health.js.map